<template>
<div class="wrapper">
  <posts :offset="this.offset" :limit="this.limit" :short="true"/>
</div>
</template>

<script>
import Posts from '@/components/posts'

export default {
  name: 'news',
  components: {
    Posts
  },
  data () {
    return {
      pagesize: 10
    }
  },
  computed: {
    offset () {
      return this.$route.params.pagenr * this.pagesize
    },
    limit () {
      return this.$route.params.pagenr * this.pagesize + this.pagesize
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/news.vue